var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcelIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_49_1",
    "data-name": "Component 49 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2439",
    "data-name": "Rectangle 2439",
    width: 24,
    height: 24,
    transform: "translate(21.001 38.781)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_17",
    "data-name": "Mask Group 17",
    transform: "translate(-21.001 -38.781)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11334",
    "data-name": "Group 11334",
    transform: "translate(21.001 39.781)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11333",
    "data-name": "Group 11333",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_102074",
    "data-name": "Path 102074",
    d: "M299.157,97.457h-9.411V100.4h2.172a.736.736,0,0,1,0,1.472h-2.172v1.472h2.172a.736.736,0,0,1,0,1.472h-2.172v1.472h2.172a.736.736,0,0,1,0,1.472h-2.172v1.472h2.172a.736.736,0,0,1,0,1.472h-2.172v2.944h9.411a.73.73,0,0,0,.724-.736V98.193A.73.73,0,0,0,299.157,97.457Zm-2.9,13.248h-1.448a.736.736,0,0,1,0-1.472h1.448a.736.736,0,0,1,0,1.472Zm0-2.944h-1.448a.736.736,0,0,1,0-1.472h1.448a.736.736,0,0,1,0,1.472Zm0-2.944h-1.448a.736.736,0,0,1,0-1.472h1.448a.736.736,0,0,1,0,1.472Zm0-2.944h-1.448a.736.736,0,0,1,0-1.472h1.448a.736.736,0,0,1,0,1.472Z",
    transform: "translate(-275.881 -94.553)",
    fill: "#207245"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102075",
    "data-name": "Path 102075",
    d: "M33.769,39.951a.7.7,0,0,0-.6-.155L21.592,42a.729.729,0,0,0-.591.72V58.848a.73.73,0,0,0,.591.72l11.582,2.2a.685.685,0,0,0,.133.013.715.715,0,0,0,.462-.169.736.736,0,0,0,.262-.565V40.516A.735.735,0,0,0,33.769,39.951ZM30.888,54.266a.714.714,0,0,1-1.021-.07l-2.1-2.436-1.846,2.405a.721.721,0,0,1-1.018.129.741.741,0,0,1-.126-1.03l2.018-2.628L24.8,48.331a.738.738,0,0,1,.068-1.034.713.713,0,0,1,1.021.069L27.7,49.457l2.144-2.792a.719.719,0,0,1,1.016-.127.741.741,0,0,1,.126,1.03l-2.315,3.015,2.289,2.65A.739.739,0,0,1,30.888,54.266Z",
    transform: "translate(-21.001 -39.781)",
    fill: "#207245"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcelIcon);
export default __webpack_public_path__ + "static/media/excel-icon.ca46c9a3d3057781d232c7111d1a3c63.svg";
export { ForwardRef as ReactComponent };